<template>
    <b-table :fields="itemFields" :items="officerMasterItems" small striped selectable no-select-on-click responsive
        @row-selected="onRowSelected" ref="selectableTable">
        <template #head(id)>
            <b-form-checkbox v-if="officerMasterItems.length > 0 &&
                officerMasterItems.filter(x => x.exists).length == 0
                " :checked="officerMasterItems.length === selectedItems.length"
                @change="toggleAllRow()"></b-form-checkbox>
        </template>

        <template #cell(id)="{ rowSelected, index, item }">
            <b-form-checkbox :checked="rowSelected" @change="toggleRow(index, rowSelected)"
                v-if="!item.exists"></b-form-checkbox>
        </template>

        <template #cell(quantity)="{ item }">
            <b-form-input type="number" :disabled="item.exists" v-model="item.quantity"></b-form-input>
        </template>
    </b-table>
</template>

<script>
export default {
    name: 'OfficerMasterItems',
    data() {
        return {

        }
    },
    computed: {
        itemFields() {
            return [
                {
                    key: 'id',
                    label: '',
                    stickyColumn: true,
                },
                {
                    key: 'name',
                    label: this.$translate('name'),
                },

                {
                    key: 'ext_reference_code',
                    label: this.$translate('code'),
                },

                {
                    key: 'quantity',
                    label: this.$translate('quantity'),
                },
            ]
        },
    },
    model: {
        prop: 'selectedItems',
        event: 'set-items',
    },
    props: {
        officerMasterItems: {
            type: Array,
            default: () => [],
        },
        selectedItems: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        ///table methods
        onRowSelected(items) {
            this.$emit('set-items', items)
        },

        selectAllRows() {
            this.$refs.selectableTable &&
                this.$refs.selectableTable.selectAllRows()
        },
        clearSelected() {
            this.$refs.selectableTable &&
                this.$refs.selectableTable.clearSelected()
        },
        toggleRow(index, rowSelected) {
            // Rows are indexed from 0, so the third row is index 2
            if (rowSelected) this.$refs.selectableTable.unselectRow(index)
            else this.$refs.selectableTable.selectRow(index)
        },

        toggleAllRow() {
            if (this.officerMasterItems.length === this.selectedItems.length)
                this.$refs.selectableTable.clearSelected()
            else this.$refs.selectableTable.selectAllRows()
        },
    },
}
</script>

<style></style>